import type {BaseComponentPart} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import type {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';

export interface ButtonGroupSkeletonProps {
  buttonWidths: string[];
}

export type ButtonGroupSkeletonComponentPart = BaseComponentPart<StreamComponentType.BUTTON_GROUP_SKELETON, ButtonGroupSkeletonProps>;

export const SKELETON_BUTTON_WIDTHS = ['132px', '156px'];
